import Vue from "vue";
import axios from "axios";
Vue.prototype.$axios = axios;

const ApiHost =
  process.env.NODE_ENV == "development"
    ? "https://api.ers-attendance.test-01.54test.cn"
    : process.env.BaseUrl;
const homeApiHr =
  process.env.NODE_ENV == "development"
    ? "" //https://ers-official.test-01.54test.cn
    : process.env.TwoUrl;
// console.log(process.env.NODE_ENV);
const UserUrl = process.env.NODE_ENV == "development"
    ? "https://ers-user.test-01.54test.cn" //
    : process.env.UserUrl;
// console.log(process.env.NODE_ENV);
const LoginApiUrl =
  process.env.NODE_ENV == "development"
    ? "https://api.ers-business.test-01.54test.cn"
    : process.env.LoginApiUrl;

const ApiUrl = {
  
  //考勤规则
  AttendanceRulePage: ApiHost + "/api/AttendanceRule/AttendanceRulePage", //考勤规则基本信息列表
  DeleteAttendanceRule: ApiHost + "/api/AttendanceRule/DeleteAttendanceRule", //考勤规则基本信息列表
  AddAttendanceRule: ApiHost + "/api/AttendanceRule/AddAttendanceRule",
  GetUpdateDetail: ApiHost + "/api/AttendanceRule/GetUpdateDetail",
  UpdateAttendanceRule: ApiHost + "/api/AttendanceRule/UpdateAttendanceRule",
  GetSetRule: ApiHost + "/api/EnterpriseSet/GetSetRule",
  //考勤组
  AttendanceGroupPage: ApiHost + "/api/AttendanceGroup/AttendanceGroupPage", //开清规则基本信息列表
  DeleteGroup: ApiHost + "/api/AttendanceGroup/DeleteGroup", //开清规则基本信息列表
  GetAttendanceRules: ApiHost + "/api/AttendanceRule/GetAttendanceRules", //获取公司所有考勤规则
  AddAttendanceGroup: ApiHost + "/api/AttendanceGroup/AddAttendanceGroup", //新增考勤组
  GetSingleAttendanceGroup:
    ApiHost + "/api/AttendanceGroup/GetSingleAttendanceGroup", //新增考勤组
  UpdateAttendanceGroup: ApiHost + "/api/AttendanceGroup/UpdateAttendanceGroup", //更新考勤组
  AttendanceGroupRefresh: ApiHost + "/api/AttendanceGroup/Refresh", //手动刷新考勤日表

  //异常设备
  Abnormal: ApiHost + "/api/Abnormal/GetAbnormalDeviceRecord", //获取异常设备
  ExportAbnormal: ApiHost + "/api/Abnormal/ExportAbnormalDeviceRecord", //获取异常设备

  //班次管理
  SelectShiftList: ApiHost + "/api/ShiftManagement/SelectShiftList", //根据公司ID查询班次列表
  GetShiftManagementByID:
    ApiHost + "/api/ShiftManagement/GetShiftManagementByID", //根据ShiftManagementID获取班次信息
  AddShift: ApiHost + "/api/ShiftManagement/AddShift", //添加班次
  DeleteShift: ApiHost + "/api/ShiftManagement/DeleteShift", //删除班次
  UpdateShift: ApiHost + "/api/ShiftManagement/UpdateShift", //修改班次
  GetCompanyShiftList: ApiHost + "/api/ShiftManagement/GetCompanyShiftList", //获取公司下所有班次
  //场地管理
  GetAddress: ApiHost + "/api/ClockInAddress/GetAddress", //获取公司场地信息
  //打卡方式
  GetAddressPage: ApiHost + "/api/ClockInAddress/GetAddressPage", //获取
  AddClockinAddress: ApiHost + "/api/ClockInAddress/AddClockinAddress", //添加
  UpdateClockinAddress: ApiHost + "/api/ClockInAddress/UpdateClockinAddress", //编辑
  DeleteClockinAddress: ApiHost + "/api/ClockInAddress/DeleteClockinAddress", //删除

  //考勤签到
  AttendanceRecordList: ApiHost + "/api/Record/AttendanceRecordList",
  GetDayRecord: ApiHost + "/api/Record/GetDayRecord",
  GetAttendanceGroupList:
    ApiHost + "/api/AttendanceGroup/GetAttendanceGroupList",
  ComputeToday: ApiHost + "/api/Record/ComputeToday",
  //人员
  GetPersonPage: ApiHost + "/api/Person/GetPersonPage", //获取分页
  AddSinglePerson: ApiHost + "/api/Person/AddSinglePerson", //添加
  DeletePerson: ApiHost + "/api/Person/DeletePerson", //删除
  DeleteBatchPerson: ApiHost + "/api/Person/DeleteBatchPerson", //批量删除
  UpdatePerson: ApiHost + "/api/Person/UpdatePerson", //修改
  GetPersonStatistics: ApiHost + "/api/Person/GetPersonStatistics", //获取统计
  GetPersonInfoTemplate: ApiHost + "/api/Person/GetPersonInfoTemplate", //获取模板表
  GetPersonByIDCard: ApiHost + "/api/Person/GetPersonByIDCard", //获取对比
  ImportPersonInfo: ApiHost + "/api/Person/ImportPersonInfo", // 人员信息表导入
  ImportPersonValid: ApiHost + "/api/Person/ImportPersonValid", // 人员信息表导入校验
  InvalidPersonInfoTemplate: ApiHost + "/api/Person/InvalidPersonInfoTemplate", // 人员信息模板（导出错误名单）
  GetOrganization: ApiHost + "/api/Person/GetOrganization", //绑定树型
  
  GetPersonSelectList:ApiHost +"/api/Person/GetPersonSelectList", // 获取人员下拉列表(部门负责人)


  // DepartMent: ApiHost + "/api/Common/DepartMent", //获取组织架构树
  
  JobPosition: ApiHost + "/api/Common/JobPosition", //获取组织架构职工

  // 考勤统计
  ClockRecordList: ApiHost + "/api/Record/ClockRecordList", //获取打卡记录（原始记录）
  GetPageRepair: ApiHost + "/api/Record/GetPageRepair", //获取补卡记录（原始记录）
  GetSupplementCard: ApiHost + "/api/Person/GetSupplementCard", //姓名或身份证获取人员列表（添加补卡人员）
  GetSupplementAddress: ApiHost + "/api/ClockInAddress/Address", //获取考勤地址（添加补卡人员）
  SupplementCard: ApiHost + "/api/Record/SupplementCard", //添加补卡记录（添加补卡人员）
  ClockRecord: ApiHost + "/api/ClockFieldAudit/ClockRecord", //获取待审核打卡记录 //批量审核待审批打卡记录 单条 多条 不通过
  reqClockRecordExport: ApiHost + "/api/Record/GetClockRecordExport", //获取待审核打卡记录 //批量审核待审批打卡记录 单条 多条 不通过
  // ClockRecord: ApiHost + "/api/Record/ClockRecord",
  

  ExportRepairExcel: ApiHost + "/api/Record/ExportRepairExcel", //
  ImportRepairExcel: ApiHost + "/api/Record/ImportRepairExcel", //
  ImportLeaveExcel: ApiHost + "/api/Record/ImportLeaveExcel", //
  ExportOutExcel: ApiHost + "/api/Record/ExportOutExcel", //
  ExportLeaveExcel: ApiHost + "/api/Record/ExportLeaveExcel", //
  GetPageOut: ApiHost + "/api/Record/GetPageOut", //
  GetClockInfoList: ApiHost + "/api/Record/GetClockInfoList", //获取日表有效打卡记录

  Itinerancy: ApiHost + "/api/WeChat/Itinerancy", //确认审核外勤打卡转为内勤
  //月表统计
  GetMonthlyRecordList:
    ApiHost + "/api/AttendanceMonthlyRecord/GetMonthlyRecordList", //获取月表数据
  GetHolidayItemComputDTO:
    ApiHost + "/api/AttendanceMonthlyRecord/GetHolidayItemComputDTO", //获取月表数据
  ComputeMonthlyRecord:
    ApiHost + "/api/AttendanceMonthlyRecord/ComputeMonthlyRecord", //计算月表数据
  GetMonthlyRecord: ApiHost + "/api/AttendanceMonthlyRecord/GetMonthlyRecord", //月表导出

  // 加班规则
  Overtime: ApiHost + "/api/Overtime/Overtime", //获取加班规则分页
  OvertimeList: ApiHost + "/api/Overtime/OvertimeList  ", // 获取考勤ID

  //导出
  ExportOvertimeSt: ApiHost + "/api/Export/ExportOvertimeSt", //工作日加班记录
  ExportMissingClockSt: ApiHost + "/api/Export/ExportMissingClockSt", //获取加班规则分页
  ExportLateSt: ApiHost + "/api/Export/ExportLateSt", //迟到早退统计表
  ExportWorkSt: ApiHost + "/api/Export/ExportWorkSt", //员工工时统计表
 

  BreakoffPage: ApiHost + "/api/Breakoff/BreakoffPage", //调休分页
  BreakoffDetailPage: ApiHost + "/api/Breakoff/BreakoffDetailPage", //调休详情分页
  Breakoff: ApiHost + "/api/Breakoff/Breakoff", //修改调休

  // 假期余额
  PersonHoliday: ApiHost + "/api/PersonHoliday/PersonHoliday", //获取假期余额明细分页 //批量修改人员假期余额  //同步人员
  BalancePage: ApiHost + "/api/PersonHoliday/BalancePage", //获取已同步人员
  PersonHolidayPage: ApiHost + "/api/PersonHoliday/PersonHolidayPage", //  获取及前期余额分页
  PersonHolidayList: ApiHost + "/api/PersonHoliday/PersonHolidayList", //  获取可用的开启假期

  HolidayManagementPage:
    ApiHost + "/api/HolidayManagement/HolidayManagementPage", //假期规则列表页
  HolidayManagementState: ApiHost + "/api/HolidayManagement/HolidayManagement", //启用禁用
  DeleteHolidayManagement: ApiHost + "/api/HolidayManagement/HolidayManagement", //删除假期

  //审批管理
  GetApprovalRecordList: ApiHost + "/api/ApprovalRecord/GetApprovalRecordList", //根据姓名获取审批记录分页列表
  ApprovalPassOrBack: ApiHost + "/api/ApprovalRecord/ApprovalPassOrBack", //审批通过或驳回

  //假期余额
  holidaybalance: ApiHost + "/api/HolidayBalance/holidaybalance", //假期余额分页，同步余额

  // 假期余额同步
  // 假期规则
  holidayset: ApiHost + "/api/HolidaySet/holidayset", //假期余额分页，同步余额
  HolidayRecord: ApiHost + "/api/ApprovalRecord/HolidayRecord", //请假记录（HR端）

  //假期类型

  
  Enable: ApiHost + "/api/HolidayType/Enable", //假期类型启用或者禁用
  CheckExistApprovingLeave: ApiHost + "/api/HolidayType/CheckExistApprovingLeave", //检查是否存在审批流转的请假申请
  
  
  SetApprover: ApiHost + "/api/HolidayType/SetApprover", //审批设定


  
 

  // 工作流PC端控制器
  List: ApiHost + "/api/WorkflowInstance/List", //审批中心列表
  DetailByTaskId: ApiHost + "/api/WorkflowInstance/DetailByTaskId", //流程表单详情
  Accept: ApiHost + "/api/WorkflowInstance/Accept", //同意
  Decline: ApiHost + "/api/WorkflowInstance/Decline", //拒绝

  WorkflowMobile_Download: ApiHost + "/api/WorkflowMobile/Download", //下载文件

  
  

  //排班管理
  GetMonthPlanTableItem:
    ApiHost + "/api/AttendanceSchedule/GetMonthPlanTableItem", //排班表表头项
  GetMonthSelects: ApiHost + "/api/AttendanceSchedule/GetMonthSelects", //选择的月份
  GetMonthStatisticsTableItem:
    ApiHost + "/api/AttendanceSchedule/GetMonthStatisticsTableItem", //排班统计表头项
  GetMonthPlan: ApiHost + "/api/AttendanceSchedule/GetMonthPlan", //排班表数据
  GetMonthScheduleShift:
    ApiHost + "/api/AttendanceSchedule/GetMonthScheduleShift", //按天排班班次信息
  ScheduleShiftSave: ApiHost + "/api/AttendanceSchedule/Save", //排班表保存
  ScheduleShiftReset: ApiHost + "/api/AttendanceSchedule/Reset", //重置，当月当页排班表全部清空
  GetMonthStatistics: ApiHost + "/api/AttendanceSchedule/GetMonthStatistics", //排班统计数据
  OutputScheduleExcel: ApiHost + "/api/AttendanceSchedule/OutputScheduleExcel", //导出排班表
  InputSchedule: ApiHost + "/api/AttendanceSchedule/InputSchedule", //导入排班表

  getLoginUser: LoginApiUrl + "/User/LoginUser", // 获取登录用户信息
  getCompanyCertOrSimpleInfo:LoginApiUrl+"/Contract/CompanyCertOrSimpleInfo",//
  reqGetStatus:LoginApiUrl+"/UserProduct/GetStatus",//
  reqGetModelBand:LoginApiUrl+"/Contract/ModelBand",
  reqGetContract:LoginApiUrl+"/Contract/Agreement/HtmlContent/9",
  reqSignContract:LoginApiUrl+ "/Contract/Agreement/Sign",

  getMealList:ApiHost+"/api/Meal/GetMealList",//获取套餐列表
  getMealManagement:ApiHost+"/api/Order/GetMealManagementDTO",//获取套餐概览


  getUserIsTry:ApiHost+"/api/Order/GetUserIsTry",//获取用户是否试用过
  addUserTryCount:ApiHost+"/api/Order/AddUserTryCount",//新增试用订单
  isHaveInEffectOrderMeal:ApiHost+"/api/Order/IsHaveInEffectOrderMeal",//用户是否存在生效的套餐
  getOrderAmount:ApiHost+"/api/Order/GetOrderAmount",//计算价格
  addOrder:ApiHost+"/api/Order/AddOrder",//提交生成订单

  getOrderListPC:ApiHost+"/api/Order/GetOrderListPC",//查询订单列表
  cancelOrder:ApiHost+"/api/Order/CancelOrder",//取消订单
  getOrderInfo:ApiHost+"/api/Order/GetOrderInfo",//获取订单详情
  getAccountInfo: LoginApiUrl+"/Order/PaymentInfos?type=9",
  getWeChatPayQRcode: ApiHost+"/api/Order/GetWeChatPayQRcode/", // 获取员工学习订单微信扫码支付url
  getWeChatPayStatus: ApiHost+"/api/Order/GetWeChatPayStatus/", // 获取员工学习订单微信扫码结果

  /* 已整理 */
  // 人员管理
  ExportPersonList:ApiHost+"/api/Person/GetPersonListExport",//人员列表导出
  ImportPersonExcel: ApiHost + "/api/Person/ImportPersonExcel", // 导入人员信息
  ImportEditedPersons: ApiHost + "/api/Person/ImportEditedPersons", // 再次导入编辑后的人员信息
  PersonSelectNodeList:ApiHost+"/api/Person/GetPersonSelectNodeList",//获取直属上级人员下拉列表（级联）
  //用户信息
  GetHRLogin: ApiHost + "/api/Common/GetHRLogin", //获取登录信息
  // 部门管理
  DepartmentListApi: ApiHost + "/api/Department/DropDownList", // 部门下拉列表
  SaveSingleDepartment: ApiHost + "/api/Department/SaveSingleDepartment", // 保存单条部门(新增或编辑)
  GetDepartmentPage: ApiHost + "/api/Department/GetDepartmentPage", // 部门列表
  AddDefaultDepartment: ApiHost + "/api/Department/AddDefaultDepartment", // 添加默认部门
  DeleteDepartment: ApiHost + "/api/Department/DeleteDepartment", // 删除部门
  PersonDepartmentSelectList: ApiHost + "/api/Department/PersonDepartmentSelectList", // 人员部门下拉列表
  TransDropDownList: ApiHost + "/api/Department/TransDropDownList", // 部门下拉选择(删除迁移部门时使用)
  
  //假期管理
  GetOrganizationAll: ApiHost + "/api/Department/GetOrgStruct", //获取组织数据
  DepartMent: ApiHost + "/api/Department/DepartMent",//获取部门架构树
  GetOrganizationNew: ApiHost + "/api/Person/GetOrganizationNew", //获取人员树
  GetApiDepartmentPersonTree: ApiHost + "/api/Person/GetDepartmentPersonTree",// 获取部门人员数结构树（包含部门和人员）
  DepartMentPerson: ApiHost + "/api/Common/DepartMentPerson", //获取组织下人员
  
  //请假记录
  getLeaveList:ApiHost+"/api/HolidayTypeLeaveApply/GetLeaveRecordList",//获取请假记录列表
  getLeaveInfo:ApiHost+"/api/HolidayTypeLeaveApply/GetLeaveRecordInfo",//获取请假记录详情

  //假期类型
  GetHolidayType: ApiHost + "/api/HolidayType/GetHolidayType", //假期类型列表
  HolidayType: ApiHost + "/api/HolidayType/HolidayType", //新增假期类型
  // 审批节点控制器
  BuildNode: ApiHost + "/api/WorkflowNode/BuildNode", //审批节点建立
  WorkflowNode: ApiHost + "/api/WorkflowNode", //审批节点获取

  //假期余额
  GetHolidayTypeBalanceItem:ApiHost + "/api/HolidayType/GetHolidayTypeBalanceItem", //假期余额列表的表头项
  Balance: ApiHost + "/api/HolidayType/Balance", //假期余额列表
  ExportHolidayTypeBalance: ApiHost + "/api/Export/ExportHolidayTypeBalance", //假期余额列表导出
  GetPersonLogList:ApiHost+"/api/HolidayType/Balance/GetPersonLogList",//获取假期余额流水
  SetHolidayBalance:ApiHost+"/api/HolidayType/Balance/SetHolidayBalance",//批量修改假期余额

  // 微信关注
  GetUserSceneRecord: LoginApiUrl + "/User/GetUserSceneRecord", //获取用户关注场景记录
  SendUserSceneRecord: LoginApiUrl + "/User/SendUserSceneRecord", //发送用户关注场景记录
};

function getCookie(name) {
  var matches = document.cookie.match(
    new RegExp("(?:^|; )" + name + "=([^;]*)")
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

axios.defaults.headers.common["Path"] = "Hr";
axios.defaults.withCredentials = true;
axios.defaults.headers.Authorization = `Bearer ` + getCookie('pcToken');

const load = function(method, url, successback, params, data) {
  var _this = this;
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: url,
      params: params,
      data: data
    })
      .then(
        res => {
          successback(res);
          return false;
        },
        err => {
          console.log(err);
          _this.$store.state.fullscreenLoading = false;
          return ResponseJudge(err);
        }
      )
      .catch(error => {
        console.log(error);
        console.log(22);
      });
  });
};
let _this = this;
function ResponseJudge(error) {
  if (!error.response) {
    _this.$message.error('网络错误');
    // alert("网络错误");
  } else if (error.response.status == 301) {
    window.location.href = homeApiHr;
  } else if (error.response.status == 401) {
    window.location.href = homeApiHr;
    // location.href=""
    // alert("请求错误")
  } else if (error.response.status == 404) {
    _this.$message.error('请求失败！');
  } else if (error.response.status == 408) {
    _this.$message.error('请求超时！');
  } else if (error.response.status == 500) {
    _this.$message.error('未知的错误！');
  } else if (error.response.status == 500) {
    _this.$message.error('服务器不支持！');
  } else if (!error.response) {
    _this.$message.error('网络错误');
  } else {
    _this.$message.error('请求异常！');
  }
}

export { load, ApiUrl, homeApiHr, LoginApiUrl, UserUrl, getCookie };



// WEBPACK FOOTER //
// ./src/assets/js/api.js